import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { useGlobalHotKey } from 'containers/GlobalHotKeys';
import { appRefreshAll } from 'data/app/actions';

const RefreshHotKeys = () => {
  const dispatch = useDispatch();
  const onRefreshAll = useCallback(() => {
    dispatch(appRefreshAll(undefined, { context: 'hotkey' }));
  }, [dispatch]);
  useGlobalHotKey({
    description: 'Refresh All',
    shiftKey: true,
    altKey: true,
    code: 'KeyR',
    callback: onRefreshAll,
  });

  return null;
};
export default RefreshHotKeys;
